import { render } from "./CountUp.vue?vue&type=template&id=705b2370"
import script from "./CountUp.vue?vue&type=script&lang=js"
export * from "./CountUp.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__